import {HeaderMenuIcon} from './header-menu-icon';
import {HeaderMenuItem} from './header-menu-item';

export class HeaderMenu {

  icon: HeaderMenuIcon;
  items: HeaderMenuItem[];

}
